const mainColors = {
  primary: '#008080',
  purple: '#a259e6',
  brown: '#d08c6e',
  pink: '#f50057',
  neutral: '#b5bcc7',
  success: '#4caf50',
  warning: '#ff9800',
  danger: '#ef5350',
  info: '#64b5f6',
};

export const colors = {
  light: {
    bg: '#f7f9fc',
    surface: '#ffffff',
    surfaceAlt: '#f1f3f6',
    text: 'rgba(0, 0, 0, 0.87)',
    textMuted: 'rgba(0, 0, 0, 0.6)',
    border: 'rgba(0, 0, 0, 0.22)',
    divider: 'rgba(0, 0, 0, 0.22)',
    ...mainColors,
  },
  dark: {
    bg: 'rgba(0, 0, 0, 0.25)',
    surface: '#202025',
    surfaceAlt: '#202025',
    text: '#FFFFFF',
    textMuted: 'rgba(255, 255, 255, 0.7)',
    border: 'rgba(255,255,255,0.14)',
    divider: 'rgba(255,255,255,0.14)',
    ...mainColors,
  },
} as const;

export type ColorMode = keyof typeof colors;
